import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function AccountMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">Financial Accounting</h5>

            <div className="row">

                <MenuCard link="/add-bank" title="Add Bank" icon="fa-solid fa-building-columns" color="#0d6efd"/>

                <MenuCard link="/add-deposit" title="Add Deposit" icon="fa-solid fa-money-bill-transfer"
                          color="#20c997"/>

                <MenuCard link="/add-cheque" title="Add Cheque" icon="fa-solid fa-money-check" color="#fd7e14"/>

                <MenuCard link="/account-report" title="Bank Statement" icon="fa-solid fa-file-invoice"
                          color="#6f42c1"/>
                {/* =====================================
    ERP FINANCE
===================================== */}

                <MenuCard
                    link="/general-ledger"
                    title="General Ledger"
                    icon="fa-solid fa-book"
                    color="#dc3545"
                />

                <MenuCard
                    link="/trial-balance"
                    title="Trial Balance"
                    icon="fa-solid fa-scale-balanced"
                    color="#20c997"
                />

                <MenuCard
                    link="/profit-loss"
                    title="Profit & Loss"
                    icon="fa-solid fa-chart-line"
                    color="#6610f2"
                />

                <MenuCard
                    link="/balance-sheet"
                    title="Balance Sheet"
                    icon="fa-solid fa-sheet-plastic"
                    color="#0dcaf0"
                />

                <MenuCard
                    link="/accounts-receivable"
                    title="Accounts Receivable"
                    icon="fa-solid fa-hand-holding-dollar"
                    color="#ffc107"
                />

                <MenuCard
                    link="/accounts-payable"
                    title="Accounts Payable"
                    icon="fa-solid fa-file-circle-minus"
                    color="#d63384"
                />

                <MenuCard
                    link="/budget-master"
                    title="Budget Master"
                    icon="fa-solid fa-wallet"
                    color="#6f42c1"
                />

                <MenuCard
                    link="/budget-detail"
                    title="Budget Detail"
                    icon="fa-solid fa-sack-dollar"
                    color="#fd7e14"
                />

                <MenuCard
                    link="/budget-vs-actual"
                    title="Budget Vs Actual"
                    icon="fa-solid fa-chart-pie"
                    color="#6610f2"
                />
            </div>

        </section>
    )
}
export default AccountMenu;